import { Alert, Box, Button, Card, CardActions, CardContent, Snackbar, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { fireauth, selectAuthUser } from '../auth/AuthSlice'
import { useAppSelector } from '../../app/hooks'
import CopyToClipboard from 'react-copy-to-clipboard'
import { Check, ContentCopy, Refresh } from '@mui/icons-material'
import { parseJwt } from '../utils/JwtUtil'

function Diagnostics() {
  const authUser = useAppSelector(selectAuthUser)
  const [copied, setCopied] = useState(false)
  const [token, setToken] = useState<string>('')
  const [parsed, setParsed] = useState<any>()
  const [expires, setExpires] = useState('')
  const handleCloseCopied = () => { setCopied(false) }
  useEffect(() => {
    refreshAccessToken(false)
  }, [])
  const refreshAccessToken = (force: boolean) => {
    fireauth.currentUser?.getIdToken(force).then((token) => {
      setToken(token)
      setParsed(parseJwt(token))
      const d = new Date(parsed.exp * 1000)
      setExpires(`${d.getFullYear()}/${d.getMonth()}/${d.getDate()} ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`);
    })
  }
  return (<>
    {authUser && <Card sx={{ width: 350 }}>
      <CardContent>
        <Typography color="text.secondary" gutterBottom>
          Auth token
        </Typography>
        <Typography variant="h5" component="div">
          {token?.substring(0, 5)}..
        </Typography>
        <Typography sx={{ fontSize: 12, mb: 1.5 }} variant="body2" color="text.secondary">
          Expires: {`${expires}`}
        </Typography>
        <CardActions>
          <CopyToClipboard onCopy={() => setCopied(true)} text={token}>
            <Button variant='contained'><ContentCopy /></Button>
          </CopyToClipboard>
          <Button variant='contained' onClick={() => { refreshAccessToken(true) }}>
            <Refresh />
          </Button>
        </CardActions>
      </CardContent>
    </Card>}
    <Snackbar open={copied} autoHideDuration={6000} onClose={handleCloseCopied}>
      <Alert icon={<Check fontSize="inherit" />} onClose={handleCloseCopied} sx={{ width: '100%' }}>
        Copied!
      </Alert>
    </Snackbar>
  </>)
}

export default Diagnostics